<template>
    <a class="news_list" :href="`/News?Id=${urlId}`">
        <div class="title">
            <div v-if="date" class="gray">{{date?$moment(date).format("YYYY-MM-DD") : ''}}</div>
            <div class="category badges badges_brown">{{category}}</div>
        </div>
        <div class="intro">{{ctrltext(content)}}</div>
    </a>
</template>
<script>
import Common from "@/common";
export default {
    name: "NewsList",
    props: ["urlId", "date", "category", "content"],
    methods: {
        ctrltext(text) {
            let Str = Common.Ctrltext(text, 30);
            return Str;
        }
    }
};
</script>
<style scoped>
.news_list {
    padding: 15px 10px;
    border-bottom: 1px solid #ccc;
    /* margin: 24px 0; */
    text-decoration: none;
    margin-bottom: 2rem;
}
.news_list .title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}
.news_list .title div:nth-child(1) {
    min-width: 85px;
}
.news_list .title .category {
    margin: 0 10px;
    border-radius: 3px;
}
.news_list .intro {
    margin-top: 10px;
    line-height: 1.5;
    letter-spacing: 2px;
    color: #888;
    transition: 0.35s;
}
.news_list:hover .intro {
    color: #ee8b59;
}
</style>



// WEBPACK FOOTER //
// src/components/index/NewsList.vue